import React, { useEffect, useState } from "react"
import Head from "next/head"
import DOMPurify from "isomorphic-dompurify"
import { EMPTY_PIXEL } from "@/constants"

const NextHead = props => {
  const {
    title = "",
    description = "",
    templateName = "",
    fullUrl = "",
    psKey = "",
    psCountry = "",
    psLanguage = "",
    pageUrl = "",
    metaLanguage = "",
    pdpData: {
      ProductBrandName_s: productName = "",
      productName_s: partsName = "",
      // ProductDescriptionProductShort_s: productDescription = "",
      "Color.SKU.Details_ss": skuDetails = [],
      productIsInStock_b: available = true,
      masterVariantDataResponse: variants = [],
      productName_s: productFullName = "",
      metaDescription_s: productMetaDescription = "",
    } = {},
    pdpData = {},
    initialImageFullUrl = "",
    isPart = false,
    skuId = "",
    siteName = "",
    isBundleProduct = false,
    currencyCode = "USD",
    persona = "GST",
  } = props
  const selectedSkuDetails =
    skuDetails?.find(item => item.includes(skuId)) ?? ""
  const selectSkuList = selectedSkuDetails?.split("|") ?? []
  const selectedSku = selectSkuList[selectSkuList.length - 1] ?? ""
  const [masterVariant, setMasterVariant] = useState([])
  const [otherVariants, setOtherVariants] = useState([])
  let showroomAddress = "";
  let breadCrumb = [];
  extractTeaserDescriptions(props)
  extractBreadCrumb(props)

  useEffect(() => {
    if (variants.length > 0) {
      const masterVariant = variants.filter(variant => variant.masterVariant_b)
      const otherVariant = variants.filter(variant => !variant.masterVariant_b)
      setMasterVariant(masterVariant)
      setOtherVariants(otherVariant)
    }
  }, [variants])

  // Recursive extractor for Find a showroom
  function extractTeaserDescriptions(data) {
    if(fullUrl.includes('/find-a-showroom/')){
      if (Array.isArray(data)) {
        data.forEach(item => extractTeaserDescriptions(item));
      } else if (typeof data === "object" && data !== null) {
        if (data[":type"] === "annsacks/components/teaser_v2" && data.description) {
          if(data.description.includes('tel:')){
            showroomAddress = data.description
            return
          }
        }else{
          const itemsOrder = data[":itemsOrder"]
          return itemsOrder?.map((itemOrder, idx) => {
            const items = data[":items"][itemOrder]
            if(showroomAddress === "") 
              extractTeaserDescriptions(items)
            else  
              return
          })
        }
      }
    }
  }
  
  // Recursive extractor
  function extractBreadCrumb(data) {
    if (Array.isArray(data)) {
      data.forEach(item => extractBreadCrumb(item, results));
    } else if (typeof data === "object" && data !== null) {
      if (data[":type"] === "kf/components/breadcrumb/v1/breadcrumb" && Array.isArray(data["items"])) {
         breadCrumb = data["items"]
         return
      }else{
          const itemsOrder = data[":itemsOrder"]
          return itemsOrder?.map((itemOrder, idx) => {
            const items = data[":items"][itemOrder]
            if(breadCrumb.length === 0) 
              extractBreadCrumb(items)
            else  
              return
          })
      }
    }
  }

  const getVariantImage = (variantImages, tmpSkuId) => {
    let initialImgUrl = ""
    let initialImageFullUrl = ""
    let variantImageLabels = []
    let variantImageURLs = []
    if (variantImages?.length) {
      const selVarImageUrls = []
      const selVarImageLabels = []
      variantImages.forEach(img => {
        const imgDetail = img.split("|")
        if (tmpSkuId === imgDetail[0]) {
          selVarImageLabels.push(imgDetail[4] ?? "")
          selVarImageUrls.push(
            imgDetail[imgDetail.length - 1]
              ? imgDetail[imgDetail.length - 1]
              : EMPTY_PIXEL
          )
        } else if (!variants.find(v => v === imgDetail[0])) {
          variantImageLabels.push(imgDetail[4] ?? "")
          variantImageURLs.push(
            imgDetail[imgDetail.length - 1]
              ? imgDetail[imgDetail.length - 1]
              : EMPTY_PIXEL
          )
        }
      })
      variantImageLabels = [...selVarImageLabels, ...variantImageLabels]
      variantImageURLs = [...selVarImageUrls, ...variantImageURLs]
      if (variantImageURLs.length < 1) {
        variantImageLabels.push(tmpSkuId)
        variantImageURLs.push(EMPTY_PIXEL)
      }
    } else {
      variantImageLabels.push(tmpSkuId)
      variantImageURLs.push(EMPTY_PIXEL)
    }
    const assetIdArray = variantImageURLs
      ? variantImageURLs[0].split("PAWEB/")
      : [""]
    initialImgUrl = assetIdArray.length > 1 ? assetIdArray[1] : ""
    initialImageFullUrl =
      variantImageURLs.find(image => image.includes(initialImgUrl)) ?? ""
    return initialImageFullUrl
  }

  const getVariantsSchema = () => {
    let variantsSchema = []
    if (otherVariants.length > 0) {
      variantsSchema = variants.map(variant => {
        const skuId = variant?.sku_s ?? ""
        const selectedSkuDetails =
          skuDetails?.find(item => item.includes(skuId)) ?? ""
        const selectSkuList = selectedSkuDetails?.split("|") ?? []
        const selectedSku = selectSkuList[selectSkuList.length - 1] ?? ""
        return {
          "@type": "Product",
          sku: selectedSku,
          gtin: variant?.SKUUPCCode_s ?? "",
          image: getVariantImage(
            variant["productImages.labelWithUrl_ss"],
            variant.sku_s
          ),
          name: variant?.productName_s ?? "",
          description: variant?.metaDescription_s ?? "",
          color: variant?.ColorFinish_s ?? "",
          offers: {
            "@type": "Offer",
            url: `${fullUrl}?skuId=${variant?.sku_s ?? ""}`,
            priceCurrency: currencyCode || "USD",
            price: variant?.[`priceList.${persona}.finalPrice_d`] ?? 0,
            itemCondition: "https://schema.org/NewCondition",
            availability: variant.productIsInStock_b
              ? "https://schema.org/InStock"
              : "https://schema.org/OutOfStock",
          },
        }
      })
    }
    return variantsSchema
  }

  const productSchema =
    otherVariants.length > 0
      ? [
          {
            "@context": "https://schema.org",
            "@type": "ProductGroup",
            "@id": fullUrl,
            url: fullUrl,
            additionalType: isPart ? "Service Part" : "",
            name: isPart
              ? partsName
              : isBundleProduct
              ? partsName
              : productFullName,
            image: initialImageFullUrl,
            description: isBundleProduct ? partsName : productMetaDescription,
            sku: isBundleProduct ? skuId : selectedSku || skuId,
            gtin: masterVariant?.[0]?.SKUUPCCode_s ?? "",
            brand: {
              "@type": "Brand",
              name: siteName,
            },
            productGroupID: isBundleProduct ? skuId : selectedSku,
            variesBy: ["https://schema.org/color"],
            hasVariant: getVariantsSchema(),
          },
        ]
      : {
          "@context": "https://schema.org",
          "@type": "Product",
          "@id": fullUrl,
          url: fullUrl,
          additionalType: isPart ? "Service Part" : "",
          name: isPart
            ? partsName
            : isBundleProduct
            ? partsName
            : productFullName,
          image: initialImageFullUrl,
          description: isBundleProduct ? partsName : productMetaDescription,
          sku: isBundleProduct ? skuId : selectedSku || skuId,
          gtin: masterVariant?.[0]?.SKUUPCCode_s ?? "",
          priceCurrency: currencyCode || "USD",
          brand: {
            "@type": "Brand",
            name: siteName,
          },
          offers: {
            "@type": "Offer",
            price: pdpData?.[`priceList.${persona || "GST"}.finalPrice_d`] ?? 0,
            priceCurrency: currencyCode || "USD",
            availability: available
              ? "https://schema.org/InStock"
              : "https://schema.org/OutOfStock",
            itemCondition: "http://schema.org/NewCondition",
          },
          hasVariant: getVariantsSchema(),
        }

  return (
    <Head>
      {title && (
        <>
          <title>{title}</title>
          <meta property="og:title" content={title} />
        </>
      )}
      <meta name="keywords" content="Kohler US Plumbing Bathroom Kitchen" />
      {description && (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
        </>
      )}
      {pageUrl ? <meta property="og:url" content={pageUrl} /> : null}
      {templateName ? <meta property="og:type" content={templateName} /> : null}
      {metaLanguage ? (
        <meta
          property="og:locale"
          content={metaLanguage?.toLocaleLowerCase()}
        />
      ) : null}
      {fullUrl ? <link rel="canonical" href={fullUrl} /> : null}
      {psKey ? <meta name="ps-key" content={psKey} /> : null}
      {psCountry ? <meta name="ps-country" content={psCountry} /> : null}
      {psLanguage ? <meta name="ps-language" content={psLanguage} /> : null}
      {/* need to use dangerouslySetInnerHTML in the below block to prevent default encoding */}
      {productName || partsName ? (
        <script
          key="structured-data"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(JSON.stringify(productSchema)),
          }}
        />
      ) : null}
      {showroomAddress.includes("tel:") ? (
        <script
          key="structured-data-showroom"
          type="application/showroom+json"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(JSON.stringify({
                                          description: showroomAddress,
                                          name: title
                                        })),
          }}
        />
      ): null}
      {breadCrumb?.length > 0 ? (
        <script
          key="structured-data-breadcrumb"
          type="application/breadcrumb+json"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(JSON.stringify(breadCrumb)),
          }}
        />
      ): null}
    </Head>
  )
}

export default NextHead
